import { Dialog } from '@material-ui/core';
import { FC } from 'react';

import { LocationObject } from 'src/general/components/SetLocationPopup/EnterLocationScreen/SetLocation/SetLocation.types';

import { EnterLocationScreen } from './EnterLocationScreen/EnterLocationScreen';
import { HandoverOptionsScreen } from './HandoverOptionsScreen/HandoverOptionsScreen';
import classes from './SetLocationPopup.module.scss';
import { SetLocationPopupMicrocopyProps } from './SetLocationPopup.types';

export type SetLocationPopupProps = {
  open: boolean;
  onClose: () => void;
  onChange: (value: any) => void;
  handleEditLocation: () => void;
  location?: LocationObject;
  microcopy: SetLocationPopupMicrocopyProps;
};

export const SetLocationPopup: FC<SetLocationPopupProps> = ({
  open,
  onClose,
  onChange,
  handleEditLocation,
  location,
  microcopy,
}) => (
  <Dialog
    open={open}
    fullWidth
    onClose={onClose}
    maxWidth="sm"
    className={classes.container}
    data-testid="PopUpDeliveryLocation"
  >
    <div className={classes.contentWrapper}>
      {location ? (
        <HandoverOptionsScreen
          onClose={onClose}
          onEditLocation={handleEditLocation}
          location={location}
          microcopy={microcopy}
        />
      ) : (
        <EnterLocationScreen microcopy={microcopy} open={open} onClose={onClose} onChange={onChange} />
      )}
    </div>
  </Dialog>
);
